import { css } from 'styled-components'

/** Keep disabled dates visibly muted in every calendar, including custom day renderers. */
export const disabledCalendarDayStyles = css`
  &:disabled {
    opacity: 0.4;
  }
`
